/* eslint-disable */
import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
  LogoutSuccess,
  SetVendorInfo,
  SignInFailure,
  SignInSuccess
} from './user_slice'
import { axiosInstance } from '../../interceptor/axios_interceptor'
import { message } from 'antd'

// create or fetch user from fireStore
// export function* getSnapshotFromUserAuth(userAuth: any): any {
//   try {
//     const userRef = yield call(createUserProfileDocument, userAuth);
//     const userSnapshot = yield userRef.get();
//     yield put(SignInSuccess({ id: userSnapshot.id, ...userSnapshot.data() }));
//   } catch (error) {
//     yield put(SignInFailure(error));
//   }
// }

// //checkUserLoggedin status
// export function* onCheckUserSession() {
//   yield takeLatest("user/checkCurrentUser", isUserAuthenticated);
// }

// export function* isUserAuthenticated(): any {
//   try {
//     const userAuth = yield getCurrentuser();
//     if (!userAuth) return;
//     yield getSnapshotFromUserAuth(userAuth);
//   } catch (error) {
//     // yield put(SignInFailure(error));
//   }
// }

//userSignup
// export function* SignInStart() {
//   yield takeLatest('user/SignInStart', signUp)
// }

export function* LogoutUser() {
  yield takeLatest('user/LogoutUser', logout)
}

export function* UpdateVendorInfo() {
  yield takeLatest('user/UpdateVendorInfo', updateVendor)
}

export function* SubmitVendorInfo() {
  yield takeLatest('user/SubmitVendorInfo', SubmitVendor)
}

export function* logout(): Generator {
  try {
    yield axiosInstance.get('/api/auth/vendorlogout')
    yield put(
      LogoutSuccess({
        UserActive: false,
        error: '',
        vendorInfo: {},
        mobileNumber: ''
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      LogoutSuccess({
        UserActive: false,
        error: '',
        vendorInfo: {},
        mobileNumber: ''
      })
    )
  }
}

export function* updateVendor({ payload }: any): Generator {
  try {
    yield axiosInstance.post('/api/vendor/saverestaurantdetails', payload)
    message.success('Vendor details successfully Updated')
  } catch (error: any) {
    console.log(error)
    message.error(error?.response?.data?.message || 'Error updating vendor details')
  }
}

export function* SubmitVendor({ payload }: any): Generator {
  try {
    const response: any = yield axiosInstance.post(
      '/api/vendor/submitrestaurantdetails',
      payload
    )
    message.success(response?.data?.message || 'Vendor details successfully Submitted')
  } catch (error: any) {
    console.log(error)
    message.error(error?.response?.data?.message || 'Error submitting vendor details')
  }
}

export function* signUp({ payload }: any): Generator {
  console.log(payload)
  //   try {
  //     const { user } = yield auth.createUserWithEmailAndPassword(email, password);
  //     if (!user) return;
  //     yield put(emailSignUpSuccess({ email, password }));
  //   } catch (error) {
  //     yield put(emailSignUpFailure(error));
  //   }

  try {
    const signInResponse = yield axiosInstance.post(
      '/api/auth/vendorlogin',
      payload
    )
    yield put(SignInSuccess({ UserActive: 'pending' }))
  } catch (error) {
    yield put(SignInFailure({ error: error }))
  }
}

export function* userSaga() {
  yield all([
    // call(SignInStart),
    call(LogoutUser),
    call(UpdateVendorInfo),
    call(SubmitVendorInfo)
  ])
}
